import { render, staticRenderFns } from "./IconSweden.vue?vue&type=template&id=0c5f54d5&"
import script from "./IconSweden.vue?vue&type=script&lang=ts&"
export * from "./IconSweden.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports